import { SWRConfiguration } from 'swr'

export const defaultSWRConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  dedupingInterval: 30000,
}

export const MIN_REPEAT_CALL_DISTANCE = 15 * 60 // 15 minutes
